<template>
  <div id="OtpForm">
    <form action>
      <div class="modal-card fixed-width dtac-font">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t("register.form.otp.title") }}</p>
        </header>
        <section class="modal-card-body">
          <div class="media">
            <div class="media-content">
              <p class="subtitle is-6">
                {{ $t("register.form.otp.number_info") }}
                <b>{{ contactNo }}</b
                >.
                <br />
                {{ $t("register.form.otp.refcode_info") }}
                <b>{{ otpInfo.reference }}</b>
              </p>
              <b-field>
                <b-input
                  maxlength="4"
                  v-model="otpCode"
                  custom-class="dtac-font"
                  :has-counter="false"
                  :placeholder="$t('register.form.otp.placeholder')"
                  required
                />
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <button class="button dtac-font" @click.prevent="$emit('close')">
            {{ $t("register.form.otp.close_btn") }}
          </button>
          <button
            class="button is-primary dtac-font"
            @click.prevent="validateOtp"
          >
            {{ $t("register.form.otp.confirm_btn") }}
          </button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import AlertManager from "@/managers/AlertManager";
import NumberApiManager from "@/apis/NumberApiManager";

export default {
  name: "OtpForm",
  props: ["contactNumber", "otpResponse"],
  data() {
    return {
      otpCode: null,
      otpInfo: this.otpResponse,
      contactNo: this.contactNumber
    };
  },
  methods: {
    validateOtp: async function() {
      if (this.otpCode) {
        const requestParams = {
          trx: this.otpInfo.transaction_id,
          otp: this.otpCode
        };
        const loadingComponent = this.$buefy.loading.open({
          container: null
        });
        const verifiedOtpResult = await NumberApiManager.requestVerifyOtp(
          requestParams
        );
        loadingComponent.close();

        this.otpCode = null;
        switch (verifiedOtpResult.code) {
          case "0":
            this.$emit("update_validOtp", verifiedOtpResult.data.contact_token);
            this.$emit("close");
            break;

          default:
            AlertManager.showErrorSnackbar(
              "Error - " + verifiedOtpResult.message
            );
            break;
        }
      }
    }
  }
};
</script>

<style scoped>
.fixed-width {
  max-width: 460px;
  padding: 0 20px;
}
</style>
